import type * as React from 'react';

import { CodeBlockLine } from '@gitbook/react-uikit';
import type { BlockProps } from '@gitbook/slate-react';

/**
 * Renderer for a line in a code block.
 */
export function BlockCodeLine(props: BlockProps): React.ReactElement {
    const { node, parent, children, editor, domRef } = props;
    const { diff, highlighted } = node.data.toFrozenObject();

    const onHighlight = () => {
        editor.change((change) => {
            change.setDataByKey(node.key, ['highlighted'], !highlighted);
        });
    };

    return (
        <CodeBlockLine
            ref={domRef}
            attributes={props.attributes}
            number={parent.getChildIndex(node.key) + 1}
            highlighting={
                diff === 'added' || diff === 'deleted' || diff === 'modified'
                    ? diff
                    : highlighted
                      ? 'highlighted'
                      : undefined
            }
            onPressGutter={editor.readOnly ? undefined : onHighlight}
        >
            {children}
        </CodeBlockLine>
    );
}
